/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from 'react'
import {  useLocation, useNavigate } from 'react-router-dom'
import { getUserByToken, login } from '../core/_requests'
import { useAuth } from '../core/Auth'
import { AuthModel } from '../core/_models'
import base64 from 'react-native-base64'


const values = {
  loginid: '',
  password: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function AutoLogin() {

  const {logout} = useAuth()
  const navigate = useNavigate();
  const { saveAuth, setCurrentUser } = useAuth()
  const search = useLocation().search;
  const user = new URLSearchParams(search).get('user');
  if (user !== null) {
    
    values.loginid = base64.decode(user!).split(';')[0];
    values.password = base64.decode(user!).split(';')[1];
  }
  const auth: AuthModel = login(values.loginid, values.password, 'login')
  useEffect(() => {
    logout();
    (async () => {

      var data = await getUserByToken(auth);
      if (data.data.Status === "Success") {
        saveAuth(auth);
        setCurrentUser(data.data);
        navigate('/');
        //setItems(data.data);
        
      }

    })();
    //document.location.reload()
  }, [])
  

  return (
   <></>
  )
}
